<script setup lang="ts">
import { computed, toRefs } from 'vue';
import sanitizeHtml from 'sanitize-html';

const props = defineProps<{ html: string }>();

const { html } = toRefs(props);

const sanitizedHtml = computed<string>(() =>
  sanitizeHtml(html.value, {
    allowedAttributes: {
      th: ['style', 'rowspan', 'colspan'],
      td: ['style', 'rowspan', 'colspan'],
      span: ['style'],
      a: ['href', 'target', 'rel'],
    },
    allowedStyles: {
      '*': {
        'text-align': [/^left$/, /^right$/, /^center$/],
        'text-decoration': [/^underline$/],
      },
      th: {
        width: [/$/],
        'vertical-align': [/$/],
      },
      td: {
        width: [/$/],
        'vertical-align': [/$/],
      },
    },
  })
);
</script>

<template>
  <div v-html="sanitizedHtml"></div>
</template>
